import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'max-sm:sticky max-sm:bottom-6 max-sm:left-0 max-sm:bg-white max-sm:px-3',
    button: 'mb-4 w-full',
    disclaimer: 'heading-xs text-text-inactive text-[12px]',
    link: 'underline underline-offset-4'
  }
});
